<div id="learning-paths-detail" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button (click)="back()">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <img [src]="'assets/images/ecommerce/product-image-placeholder.png'">
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'main.learning_paths' | translate}}
          </div>
          <div class="subtitle secondary-text">
            @if (!id) {
              <span>{{'learning_paths.add_new' | translate}}</span>
            }
            @if (id) {
              <span>{{'learning_paths.detail' | translate}}</span>
            }
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <div>
        @if (learningPath?.goToChat) {
          <button mat-raised-button
                  class="mat-white-bg"
                  (click)="openChat()">
            <span>{{ 'event.openChat' | translate }}</span>
          </button>
        }
        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          [disabled]="form.invalid || certificateInvalid()"
          (click)="addLeaningPath(true)">
          @if (!id) {
            <span>{{'main.add' | translate}}</span>
          }
          @if (id) {
            <span>{{'main.save' | translate}}</span>
          }
        </button>
        @if (id) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="deleteLP()">
            <span>{{ 'main.delete' | translate }}</span>
          </button>
        }
      </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <div class="top-container">
          <cropper [avatar]="picture" [page]="'event'" [defaultRatio]="true" (sendImg)="getImg($event)"
                   (cropperOpened)="openCropper($event)"></cropper>
          @if (learningPath?.learningPathsParticipants?.length) {
            <div class="participants-container">
              <learning-path-participant [learningPath]="learningPath" [certificates]="learningPath.certificates"
              [participants]="learningPath.learningPathsParticipants"
              [hasElearning]="hasElearning" [hasEvent]="hasEvent" [rewards]="learningPath?.learningPathsEventLevels"
              [title]="learningPath.title" [skills]="learningPath?.learningPathsSkills"
              [id]="learningPath.id" [platforms]="learningPath?.learningPathsPlatforms"></learning-path-participant>
            </div>
          }
        </div>
          <form [formGroup]="form">
            <mat-form-field class="width-100">
              <mat-label>{{ 'learning_paths.title' | translate }}</mat-label>
              <input formControlName="title" matInput required>
            </mat-form-field>
            <div class="quill-description">
              <div class="quill-title">{{ 'learning_paths.description' | translate }}</div>
              <quill-editor formControlName="description"></quill-editor>
            </div>
            <mat-form-field class="width-100">
              <mat-label>{{ 'main.learningCategory' | translate}}</mat-label>
              <mat-select multiple formControlName="learningCategory">
                @for (item of learningCategories; track item.id) {
                  <mat-option [value]="item.id">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (form.get('countryId')?.enabled) {
              <mat-form-field appearance="fill" class="width-33">
                <mat-label>{{ 'event.country' | translate }}</mat-label>
                <mat-select formControlName="countryId">
                  @for (country of countries; track country.id) {
                    <mat-option [value]="country.id">
                      {{country.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (form.get('cityId')?.enabled) {
              <mat-form-field appearance="fill" class="width-33">
                <mat-label>{{ 'event.canton' | translate }}</mat-label>
                <mat-select formControlName="cityId">
                  @for (city of cities; track city) {
                    <mat-option [value]="city.id">
                      {{city.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (form.get('organizationId')?.enabled) {
              <mat-form-field appearance="fill" class="width-33">
                <mat-label>{{ 'event.organization' | translate }}</mat-label>
                <mat-select formControlName="organizationId">
                  @for (org of organizations; track org.id) {
                    <mat-option [value]="org.id">
                      {{org.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (platforms && platforms.length && platforms.length > 1 && !platformId) {
              <mat-form-field class="platform">
                <mat-label>{{'event.platforms' | translate}}</mat-label>
                <mat-select  multiple (selectionChange)="changePlatforms($event)"
                             [value]="selectedPlatforms">
                  @for (plat of platforms; track plat.id) {
                    <mat-option [value]="plat.id">
                      {{plat.title}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (showLevel) {
              <mat-form-field appearance="fill" class="level">
                <mat-label>{{ 'event.event_level' | translate }}</mat-label>
                <mat-select placeholder="{{ 'event.event_level_desc' | translate }}"
                            formControlName="eventLevel" multiple>
                  @for (el of eventLevels; track el.value) {
                    <mat-option [value]="el.value">
                      {{ el.label }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="level">
                <mat-label>{{ 'event.skill_selection' | translate }}</mat-label>
                <mat-select placeholder="{{ 'event.skill_selection_description' | translate }}"
                            formControlName="skills" multiple>
                  @for (comp of competencies; track comp.id) {
                    <mat-optgroup [label]="comp.title">
                      @for (skill of comp.skills; track skill.id) {
                        <mat-option [value]="skill.id">
                          {{ skill.title }}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field class="width-100">
              <mat-select placeholder="{{'user.targetGroup' | translate}}" [(ngModel)]="array"
                          [ngModelOptions]="{standalone: true}"
                          multiple>
                <mat-optgroup>
                  <div style="cursor: pointer;display: flex;align-items: center;"
                       (click)="selectAll()">
                    @if (selectAllTargetGroup) {
                      <i class="material-icons">
                        check_box
                      </i>
                    }
                    @if (!selectAllTargetGroup) {
                      <i class="material-icons">
                        check_box_outline_blank
                      </i>
                    }
                    <b style="font-size: 24px;">{{ 'frontUser.selectAll' | translate }}</b>
                  </div>
                </mat-optgroup>
                @for (group of targetGroups; track group.name; let i = $index) {
                  <mat-optgroup>
                    <div style="cursor: pointer;display: flex;
  align-items: center;" (click)="setAll(group.name, i)">
                      @if (group.selected) {
                        <i class="material-icons">
                          check_box
                        </i>
                      }
                      @if (!group.selected) {
                        <i class="material-icons">
                          check_box_outline_blank
                        </i>
                      }
                      <b style="font-size: large;">{{ group.name }}</b></div>
                    @for (pokemon of group.data; track pokemon.id) {
                      <mat-option [value]="pokemon.id" (click)="changeTG()">
                        {{ pokemon.ageMask }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-33">
              <mat-label>{{ 'learning_paths.visibility' | translate }}</mat-label>
              <mat-select formControlName="visibility">
                <mat-option [value]="'internal'">
                  interne Veranstaltung
                </mat-option>
                <mat-option [value]="'public'">
                  öffentliche Veranstaltung
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-33">
              <mat-label>{{ 'learning_paths.startDate' | translate }}</mat-label>
              <input matInput readonly formControlName="startDate">
              <input [matDatepicker]="startDate" matInput readonly style="display: none" [min]="minStartDate">
              @if (form.get('startDate').value) {
                <mat-icon (click)="cleanStartDate()" class="clean-icon">clear</mat-icon>
              }
              <mat-datepicker-toggle matSuffix [for]="startDate" class="calendar-button"></mat-datepicker-toggle>
              <mat-datepicker #startDate disabled="false"
                              (closed)="closePicker('startDate', startDate)"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="width-33">
              <mat-label>{{ 'learning_paths.finishDate' | translate }}</mat-label>
              <input matInput readonly formControlName="finishDate">
              <input [matDatepicker]="finishDate" matInput readonly style="display: none" [min]="minFinishDate">
              @if (form.get('finishDate').value) {
                <mat-icon (click)="cleanFinishDate()" class="clean-icon">clear</mat-icon>
              }
              <mat-datepicker-toggle matSuffix [for]="finishDate" class="calendar-button"></mat-datepicker-toggle>
              <mat-datepicker #finishDate disabled="false"
                              (closed)="closePicker('finishDate', finishDate)"></mat-datepicker>
            </mat-form-field>
            <mat-checkbox formControlName="hideEvents" class="full-width">
               {{ 'learning_paths.hideEvents' | translate }}
            </mat-checkbox>
          </form>
        @if (certificateEnabled()) {
          <mat-card class="content-mat-card">
            <mat-card-header>
              <mat-card-title>{{ 'certificate.title' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <certificate-setting (certificateFormResult)="onCertificateFormResult($event)"
                                   [certificateData]="certificateData()"
                                   [organizationId]="+form.controls.organizationId.value || null"></certificate-setting>
            </mat-card-content>
          </mat-card>
        }
        @if (forumChatEnabled()) {
          <mat-card class="content-mat-card">
            <mat-card-header>
              <mat-card-title>{{ 'event.chat_settings' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <chat-setting (chatFormResult)="onChatFormResult($event)"
                            [chatData]="chatSetting"></chat-setting>
            </mat-card-content>
          </mat-card>
        }
        <mat-card class="content-mat-card">
          <mat-card-header>
            <mat-card-title>
              {{'learning_paths.add_content' | translate}}
              (<span [style.color]="'orange'">{{'main.events' | translate}}</span>,
              <span [style.color]="'green'"> {{'main.eLearning' | translate}}</span>,
              <span [style.color]="'blue'"> {{'hubOverview.task' | translate}}</span>)
            </mat-card-title>
            <div class="buttons" [matTooltip]="'learning_paths.disableButtonInfo' | translate"
            [matTooltipDisabled]="form.get('organizationId').value">
              <button mat-raised-button class="save-product-button mat-white-bg" (click)="addEvent()"
              [disabled]="!form.get('organizationId').value">
                {{'learning_paths.add_event' | translate}}</button>
              <button mat-raised-button class="save-product-button mat-white-bg" (click)="addElearning()"
                      [disabled]="!form.get('organizationId').value">
                {{'learning_paths.add_elearning' | translate}}</button>
              <button mat-raised-button class="save-product-button mat-white-bg" (click)="addTask()"
              [disabled]="!form.get('organizationId').value">
                {{'learning_paths.add_task' | translate}}</button>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="content-container" cdkDropList (cdkDropListDropped)="drop($event)">
              @for (item of content; track item) {
                <div cdkDrag class="content-item {{item.contentType}}">
                  <div class="remove" (click)="removeFromContent(item)">
                    <mat-icon>close</mat-icon>
                  </div>
                  <div class="image" [style.background-image]="'url(' + getImage(item.picture) + ')' "></div>
                  <div class="item-title">{{item.title}}</div>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>

      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->
</div>
<ngx-spinner
  name="getLearningPath"
  [fullScreen]="true"
  [zIndex]="99999"
  bdColor="rgba(0,0,0,0.5)"
  size="medium"
  color="#fff"
  type="line-spin-clockwise-fade">
</ngx-spinner>
